import ReactModal from "react-modal";
import {color_transparent} from "../../constants/colors";
import { MODAL_Z_INDEX_BASE } from "../../constants/layers";
import React from "react";
import { useWindowDimensions } from "../../utils";

export const ModalDefault = ({
    children,
    isOpen,
    modalWidth = 380,
    centerOnMobile = false,
    centerAlways = false,
    mobileBottomSheet = false,
    onRequestClose = () => {},
    onAfterOpen = () => {}
}) => {
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();
        
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            onAfterOpen={onAfterOpen}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                    backdropFilter: "blur(8px)",
                    overflow: "hidden",
                    overscrollBehavior: "none",
                    zIndex: MODAL_Z_INDEX_BASE,
                },
                content: {
                    backgroundColor: color_transparent,
                    borderColor: color_transparent,
                    borderRadius: mobileBottomSheet ? 0 : undefined,
                    ...(mobileBottomSheet
                        ? {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            padding: 0,
                            border: "none",
                            background: "transparent",
                        }
                        : {}),
                    zIndex: MODAL_Z_INDEX_BASE + 1,
                    ...(centerAlways
                        ? {
                            width: "min-content",
                            maxWidth: "calc(100vw - 24px)",
                            maxHeight: "calc(100vh - 24px)",
                            top: "50%",
                            left: "50%",
                            right: "auto",
                            bottom: "auto",
                            transform: "translate(-50%, -50%)",
                            overflow: "hidden",
                        }
                        : {}),
                    width: screenWidth <= 460
                        ? (mobileBottomSheet ? "100%" : (centerOnMobile ? "min-content" : "100%"))
                        : "min-content",
                    height: mobileBottomSheet ? "100dvh" : "min-content",
                    maxWidth: screenWidth <= 460
                        ? (mobileBottomSheet ? "100vw" : "calc(100vw - 24px)")
                        : undefined,
                    maxHeight: screenWidth <= 460
                        ? (mobileBottomSheet
                            ? "100dvh"
                            : (centerOnMobile ? "calc(100vh - 24px)" : "calc(100vh - 60px)"))
                        : undefined,
                    margin: mobileBottomSheet ? 0 : "0 auto",
                    padding: mobileBottomSheet ? 0 : undefined,
                    overflow: "hidden",
                    display: mobileBottomSheet ? "flex" : undefined,
                    justifyContent: mobileBottomSheet ? "flex-end" : undefined,
                    ...(!centerAlways && (screenWidth > 460
                        ? { inset: "40px" }
                        : centerOnMobile
                            ? {
                                top: "50%",
                                left: "50%",
                                right: "auto",
                                bottom: "auto",
                                transform: "translate(-50%, -50%)",
                            }
                            : (mobileBottomSheet
                                ? { inset: "0", top: 0, right: 0, bottom: 0, left: 0, padding: 0 }
                                : { top: "48px", right: "12px", bottom: "12px", left: "12px" }))),
                    boxSizing: "border-box",
                }
            }}
        >
            {children}
        </ReactModal>
    )
}